import Login from './Login';

export const PAGE_LOGIN = '/signup';

export default Login;
